<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>线索列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <!-- 搜索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="城市">
          <el-select v-model="listQuery.cityId" style="width:150px" clearable placeholder="请选择城市" filterable>
            <el-option v-for="(item, index) in cityList" :key="index" :label="item.cityName"
              :value="item.id + ''"></el-option>
          </el-select>
        </el-form-item>



        <el-form-item label="联系电话">
          <el-input v-model="listQuery.tel" type="number" style="width:150px" placeholder="请输入联系电话"
            clearable></el-input>
        </el-form-item>

        <el-form-item label="服务者编号">
          <el-input v-model="listQuery.workerNo" style="width:150px" placeholder="请输入服务者编号" clearable></el-input>
        </el-form-item>

        <el-form-item label="服务者姓名">
          <el-input v-model="listQuery.workerName" style="width:150px" placeholder="请输入服务者姓名" clearable></el-input>
        </el-form-item>

        <el-form-item label="线索状态">
          <el-select v-model="listQuery.state" clearable multiple style="width:150px" placeholder="选择线索状态"
            @change="chooseState" filterable>
            <el-option v-for="(item, index) in clueState" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="面试状态">
          <el-select v-model="listQuery.ivState" clearable multiple style="width:150px" placeholder="选择面试状态" filterable>
            <el-option v-for="(item, index) in ivStateMap" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="培训状态">
          <el-select v-model="listQuery.studyState" clearable multiple style="width:150px" placeholder="选择培训状态"
            filterable>
            <el-option v-for="(item, index) in studyStateMap" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="跟单状态">
          <el-select v-model="listQuery.onjobState" clearable multiple style="width:150px" placeholder="选择跟单状态"
            filterable>
            <el-option v-for="(item, index) in onjobStateMap" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="求职意向">
          <el-select style="width:150px" v-model="listQuery.joinDemand" clearable placeholder="选择求职意向" filterable>
            <el-option v-for="(item, index) in workTypes" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="线索标签">
          <el-select v-model="listQuery.labelType" style="width:150px" clearable placeholder="选择线索标签" filterable>
            <el-option label="手动录入" :value="1"></el-option>
            <el-option label="招招盈二维码" :value="2"></el-option>
            <el-option label="后台导入" :value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否符合">
          <el-select v-model="listQuery.satisfy" style="width:150px" clearable placeholder="选择是否符合" filterable>
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
        </el-form-item>

         <el-form-item label="互动类型">
          <el-select v-model="listQuery.interactionType" style="width:150px" clearable placeholder="选择互动类型" filterable>
            <el-option label="私信" value="私信"></el-option>
            <el-option label="短视频" value="短视频"></el-option>
            <el-option label="企业主页" value="企业主页"></el-option>
            <el-option label="独立店铺" value="独立店铺"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="来源类型">
          <el-select v-model="listQuery.sourceType" style="width:150px" clearable placeholder="选择来源类型" filterable>
            <el-option label="转介绍" :value="4"></el-option>
            <el-option label="自有渠道" :value="7"></el-option>
            <el-option label="自招" :value="3"></el-option>
            <el-option label="外部渠道" :value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="线索来源">
          <el-input v-model="listQuery.sourceRelationName" style="width:150px" placeholder="请输入线索来源"
            clearable></el-input>
        </el-form-item>


        <el-form-item label="是否添加微信">
          <el-select v-model="listQuery.addWeixin" style="width:150px" clearable placeholder="选择是否添加微信" filterable>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="跟进人">
          <el-select :disabled="listQuery.self == 1" v-model="listQuery.handlerId" style="width:150px" clearable
            placeholder="请选择跟进人" filterable>
            <el-option v-for="(item, index) in handlerPersonList" :key="index" :label="item.userName"
              :value="item.userId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="外呼意向类型">
          <el-select   style="width:150px" v-model="listQuery.intentTypeName" multiple clearable   placeholder="请选择类型" filterable>
            <el-option v-for="(item, index) in intentTypeArr" :key="index" :label="item"
              :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="最近跟进时间">
          <el-date-picker style="width:250px" v-model="followupTimeArr" value-format="yyyy-MM-dd" type="daterange"
            range-separator="至" start-placeholder="跟进时间开始" end-placeholder="跟进时间结束"></el-date-picker>
        </el-form-item>
        <el-form-item label="下次跟进时间">
          <el-date-picker style="width:250px" v-model="nextFollowupTime" value-format="yyyy-MM-dd" type="daterange"
            range-separator="至" start-placeholder="跟进时间开始" end-placeholder="跟进时间结束"></el-date-picker>
        </el-form-item>

        <el-form-item label="创建时间">
          <el-date-picker style="width:250px" v-model="createTimeArr" value-format="yyyy-MM-dd" type="daterange"
            range-separator="至" start-placeholder="创建日期开始" end-placeholder="创建日期结束"></el-date-picker>
        </el-form-item>


        <div>
          <el-form-item label="">
            <el-switch v-model="listQuery.self" active-color="#409eff" inactive-color="#dcdfe6" active-value="1"
              inactive-value="0" active-text="我的线索" inactive-text="全部线索" @change="chooseAll">
            </el-switch>
          </el-form-item>



          <el-form-item>
            <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
            <el-button v-per="'xiansuoluru'" icon="el-icon-plus" type="primary" plan
              @click="handleCreate">录入线索</el-button>
            <a href="https://servant.lifejingzhi.com/file/salary/clueImport.xls" download="clueImport.xls">
              <el-button type="danger" icon="el-icon-download">导入模板下载</el-button>
            </a>
            <el-button type="primary" icon="el-icon-upload2" @click="uploadClue">新媒体线索导入</el-button>
            <el-button type="success" icon="el-icon-download" @click="exportClue">导出</el-button>

            <el-button type="primary" @click="batchModifyHandler">批量修改跟进人</el-button>

          </el-form-item>
        </div>
      </el-form>


      <el-tabs class="mytabs" v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="待分配" name="1"></el-tab-pane>
        <el-tab-pane label="待联系" name="11"></el-tab-pane>
        <el-tab-pane label="跟进中" name="2"></el-tab-pane>
        <el-tab-pane label="跟进成功" name="12"></el-tab-pane>
        <el-tab-pane label="上线中" name="3"></el-tab-pane>
        <el-tab-pane label="上线成功" name="13"></el-tab-pane>
        <el-tab-pane label="跟进失败" name="4"></el-tab-pane>
        <el-tab-pane label="上线失败" name="5"></el-tab-pane>
        <el-tab-pane label="全部线索" name="0"></el-tab-pane>
      </el-tabs>

      <!-- 列表数据 -->
      <el-table :data="listData" @selection-change="handleSelectionChange" :header-cell-style="{ textAlign: 'center' }"
        border style="width: 100%;margin-top:-15px;" class="table">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="clueNo" label="线索编号" width="230px">
          <template slot-scope="scope">
            <span class="columntxt">线索编号：<span class="columnval">{{ scope.row.clueNo }}</span></span><br />
            <span class="columntxt">服务者编号：<span class="columnval">{{ scope.row.workerNo }}</span></span><br />
            <span class="columntxt">线索标签：<span class="columnval">{{ labelTypeMap[scope.row.labelType]
            }}</span></span><br />
             <span class="columntxt">互动类型：<span class="columnval">{{ scope.row.interactionType }}</span></span><br />
            <span class="columntxt">求职意向：<span class="columnval"><el-tag>{{
              getqzyx(scope.row.joinDemand) }}</el-tag></span></span><br />
          </template>
        </el-table-column>

        <el-table-column prop="clueNo" label="人员信息" width="230px">
          <template slot-scope="scope">
            <span class="columntxt">姓名：<span class="columnval">{{ scope.row.workerName }}</span></span><br />
            <span class="columntxt">电话：<span class="columnval">
                <phoneTag :phone="scope.row.tel" />
              </span></span><br />
            <span class="columntxt">意向城市：<span class="columnval">{{ scope.row.cityName }}</span></span><br />
            <span class="columntxt">当前城市所在地：<span class="columnval">{{ getCityName(scope.row.currentCity)
            }},{{ scope.row.currentAddress }}</span></span><br />
             <span class="columntxt">导入标签：<span class="columnval">{{ scope.row.importLabel }}</span></span><br />
              <span class="columntxt">是否符合：<span class="columnval">{{ scope.row.satisfy }}</span></span><br />
          </template>
        </el-table-column>
        <el-table-column prop="" label="上线信息" width="180px">
          <template slot-scope="scope" v-if="scope.row.state == 3 || scope.row.state == 13">
            <span class="columntxt">上线城市：<span class="columnval">{{ scope.row.workerSupplier.cityName
                }}</span></span><br />
            <span class="columntxt">上线服务站：<span class="columnval">{{ scope.row.workerSupplier.station
                }}</span></span><br />
            <span class="columntxt">上线状态：<span class="columnval">{{ formatState(scope.row.workerSupplier.state)
                }}</span></span><br />
          </template>
        </el-table-column>

        <el-table-column prop="clueNo" label="基础信息" width="180px">
          <template slot-scope="scope">
            <span class="columntxt">年龄：<span class="columnval">{{ scope.row.age }}</span></span><br />
            <span class="columntxt">身份证：<span class="columnval">{{ scope.row.idCard }}</span></span><br />
            <span class="columntxt">是否添加微信：<span class="columnval">{{ scope.row.addWeixin==1?'是':'否' }}</span></span><br />
            <span class="columntxt">微信号：<span class="columnval">{{ scope.row.wxAccount }}</span></span><br />
            <span class="columntxt">户口社保：<span class="columnval">{{ residenceTypeMap[scope.row.residenceType] }},{{
              socialSecurityMap[scope.row.socialSecurity] }}</span></span><br />
          </template>
        </el-table-column>

        <el-table-column prop="clueNo" label="来源信息" width="200px">
          <template slot-scope="scope">
            <span class="columntxt">来源类型：<span class="columnval"> {{ sourceTypeMap[scope.row.sourceType]
            }}</span></span><br />
            <span class="columntxt">来源：<span class="columnval"> {{ scope.row.sourceRelationName }}</span></span><br />
            <span class="columntxt">归属：<span class="columnval">{{ scope.row.workerBelongName }}</span></span><br />
             <span class="columntxt">外呼意向：<span class="columnval">{{ scope.row.intentTypeName }}</span></span><br />
              <span class="columntxt">外呼时间：<span class="columnval">{{ timeFMT(scope.row.intentTime) }}</span></span><br />
          </template>
        </el-table-column>

        <el-table-column prop="clueNo" label="状态信息" width="150px">
          <template slot-scope="scope">
            <span class="columntxt">线索状态：<span class="columnval"> <el-tag
                  :type="scope.row.state == 3 ? 'success' : ''">{{
                    clueState[scope.row.state]
                  }}</el-tag></span></span><br />
            <span class="columntxt">面试状态：<span class="columnval clickable" @click="toInterview(scope.row)"
                title="点击查看面试详情">{{
                  ivStateMap[scope.row.ivState] || '未面试' }}</span></span><br />
            <span class="columntxt">培训状态：<span class="columnval clickable" @click="toStudy(scope.row)"
                title="点击查看培训详情">{{
                  studyStateMap[scope.row.studyState] || '未培训' }}</span></span><br />
            <span class="columntxt">跟单状态：<span class="columnval clickable" @click="toOnjob(scope.row)"
                title="点击查看跟单详情">{{
                  onjobStateMap[scope.row.onjobState] || '未跟单' }}</span></span><br />

              <el-button type="text" icon="el-icon-view" @click="toWorkerList(scope.row)" v-if="scope.row.state==3 &&scope.row.ivState ==5&& scope.row.studyState==2&&scope.row.onjobState==2">去上线</el-button>
          </template>
        </el-table-column>

        <el-table-column prop="clueNo" label="跟进人">
          <template slot-scope="scope">
            <span class="columntxt">跟进人：<span class="columnval">{{ scope.row.handlerName }}</span></span><br />
            <span class="columntxt">最近跟进时间：<span class="columnval">{{ timeFMT(scope.row.followupTime)
            }}</span></span><br />
            <span class="columntxt">下次跟进时间：<span class="columnval">{{ timeFMT(scope.row.nextFollowupTime)
            }}</span></span><br />
            <span class="columntxt">创建时间：<span class="columnval">{{ timeFMT(scope.row.createTime) }}</span></span><br />
          </template>
        </el-table-column>
        <el-table-column prop="clueNo" label="流失信息">
          <template slot-scope="scope">
            <!-- <span class="columntxt">流失时间：<span class="columnval">{{ timeFMT(scope.row.lossTime) }}</span></span><br /> -->
            <span class="columntxt">流失类型：<span class="columnval">{{ scope.row.lossType }}</span></span><br />
            <span class="columntxt">流失原因：<span class="columnval">{{ scope.row.lossReason }}</span></span><br />
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="120px">
          <template slot-scope="scope">
            <!-- <el-button type="text" icon="el-icon-view" @click="handleDetail(scope.row)">详细</el-button> -->
            <el-button type="text" icon="el-icon-view" @click="actionDetail(scope.row)">查看跟进记录</el-button>
              <el-button type="text" v-if="scope.row.state == 4 || scope.row.state == 5" icon="el-icon-refresh" @click="followAgainHandler(scope.row)">线索复活</el-button>
            <el-button type="text" v-if="scope.row.state == 1 || scope.row.state == 2 || scope.row.state == 11" icon="el-icon-user" @click="handleModifyHandler(scope.row)">修改跟进人</el-button>
            <el-button type="text" icon="el-icon-edit" @click="handleFollow(scope.row)"
              v-if="scope.row.state != 1 && scope.row.state != 5 && scope.row.state != 4">跟进线索</el-button>
            <el-button type="text" icon="el-icon-user" v-if="
              scope.row.state == 12 && (scope.row.ivState == 0 || scope.row.ivState == 4 || scope.row.ivState == 6)
            " @click="handleInterview(scope.row)">发起面试</el-button>
            <el-button type="text" v-if="scope.row.state == 1 || scope.row.state == 2 || scope.row.state == 11|| scope.row.state == 12"
              v-per="'xiansuoxiugai'" icon="el-icon-edit-outline" @click="handleUpdate(scope.row)">修改线索</el-button>
            <el-button v-if="scope.row.state == 12 && scope.row.ivState == 5" type="text" v-per="'xiansuoyaoyue'"
              icon="el-icon-key" @click="handleOffice(scope.row)">邀请上线</el-button>
            <!-- <el-button type="text" icon="el-icon-view" @click="resendInterviewMsg(scope.row)"
              v-if="scope.row.ivState === 1">重发面试短信</el-button> -->
            <!-- <el-button v-if="scope.row.state == 3" type="text" v-per="'xiansuoliushi'"
              icon="el-icon-close" @click="handleLoss(scope.row)">流失</el-button> -->
            <!-- <el-button v-if="scope.row.state == 2 || scope.row.state == 1 || scope.row.state == 11" type="text" icon="el-icon-key"
              @click="addClueTask(scope.row)">添加线索任务</el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
    </el-card>

    <el-dialog title="跟进记录" :visible.sync="showAction" width="700px" center>
      <el-table :data="handleActionList" border style="width: 100%; " class="table">
        <el-table-column prop="operTypeVal" label="操作类型描述" width="110px"></el-table-column>
        <el-table-column prop="comment" label="内容"></el-table-column>
        <el-table-column prop="handleName" label="操作人" width="100px"></el-table-column>
        <el-table-column prop="createTime" :formatter="dateFormatA" width="150" label="操作时间"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAction = false">关闭</el-button>
      </span>
    </el-dialog>

    <!--新增线索 -->
    <workerClueAddFormNew ref="workerClueAddFormNewRef" />
    <!-- 发起面试 -->
    <interviewAddForm ref="interviewRef" />
    <!--线索流失 -->
    <leaveLossForm ref="leaveLossFormRef" />
    <!--添加线索任务 -->
    <clueTaskAdd ref="clueTaskAddRef" />

    <!--导入线索 -->
    <importClue ref="importClueRef" />

    <!--修改跟进人 -->
    <modifyHandler ref="modifyHandlerRef" @confirm="onModifyHandlerConfirm" />

    <!--跟进线索 -->
    <followRef ref="followRef" @confirm="onFollowConfirm" />

  </div>
</template>
<script>
import Pagination from "@/components/common/Pagination";
import workercrmapi from "@/script/api/workercrmapi";
import clueDetail from "@/components/workercrm/clueDetail.vue";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import taskApi from "@/script/api/taskApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import phoneTag from "@/components/workercrm/compent/phoneTag.vue";

import workerClueAddFormNew from "@/components/workercrm/compent/workerClueAddFormNew.vue";
import interviewAddForm from "@/components/workercrm/compent/interviewAddForm.vue";
import leaveLossForm from "@/components/workercrm/compent/leaveLossForm.vue";
import clueTaskAdd from "@/components/workercrm/compent/clueTaskAdd.vue";
import importClue from "@/components/workercrm/compent/importClue.vue";
import modifyHandler from "@/components/workercrm/compent/modifyHandler.vue";
import followRef from "@/components/workercrm/compent/followRef.vue";
import moment from "moment";

let vm;
export default {
  components: {
    Pagination,
    clueDetail,
    phoneTag,
    workerClueAddFormNew,
    interviewAddForm,
    leaveLossForm,
    clueTaskAdd,
    importClue,
    modifyHandler,
    followRef
  },
  filters: {
    filterWorkerType(type) {
      if (type == 1) return "保洁";
      if (type == 2) return "保姆";
      if (type == 3) return "品类";
    }
  },
  data() {
    return {
      activeName: '11',
      multipleSelection: [],//多选
      residenceTypeMap: { 1: "农村", 2: "城镇" },
      socialSecurityMap: { 1: "社保", 2: "新农保", 3: "已退休", 4: "无" },
      sourceTypeMap: { 1: "外部渠道", 3: "自招", 4: "转介绍", 7: "自有渠道" },
      sourceName: { 1: "渠道", 2: "合伙⼈", 3: "公司BD", 4: "转介绍" },
      clueState: {
        "1": "待分配",
        "11": "待联系",
        "2": "跟进中",
        "12": "跟进成功",
        "4": "跟进失败",
        "3": "上线中",
        "13": "上线成功",
        "5": "上线失败"
      },
      ivStateMap: {
        1: "待确认",
        2: "待面试",
        4: "面试取消",
        5: "面试通过",
        6: "需再次面试",
        7: "面试淘汰"
      },
      studyStateMap: {
        0: "未培训", 1: "培训中", 2: "培训通过", 3: "培训未通过"
      },
      onjobStateMap: {
        0: "未跟单", 1: "跟单中", 2: "跟单通过", 3: "跟单未通过"
      },
      workTypes: [
        { value: 1, label: "保洁" },
        { value: 2, label: "保姆" },
        { value: 3, label: "品类" }
      ],
      labelTypeMap: { 1: "手动录入", 2: "招招盈二维码", 3: "后台导入" },
      skillGroups: [],
      supplierList: [],
      listData: [],
      cityList: [],
      sysUserList: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        handlerId: '',
        cityId: "",
        tel: "",
        workerNo: "",
        workerName: "",
        joinDemand: "",
        state: [],//线索状态1待分配，2跟进中，3上线中(原跟进成功)，4跟进失败，5上线失败 11 待联系 12跟进成功  13上线成功
        ivState: [],//面试状态 1待确认 2待面试   4面试取消(取消/未参加) 5面试通过 6需再次面试 7面试淘汰
        studyState: [],//培训状态 0未培训，1培训中，2培训通过，3培训未通过
        onjobState: [],//跟单状态 0未培训，1跟单中，2跟单完成，3跟单取消
        self: 0, //是否查询自己跟进的线索
        userId: globalData.userInfo.id,
        sourceType: "",
        sourceRelationName: "",
        labelType: "",
        addWeixin:'',
        interactionType:'',
        intentTypeName:[],
        satisfy: '',
      },
      followupTimeArr: [],
      nextFollowupTime: [],
      createTimeArr: [],

      upgradeForm: {
        clueId: "",
        comment: "",
        skillGroupId: "",
        userId: ""
      },
      rules_Upgrade: {
        comment: [
          {
            required: true,
            message: "请输入跟进内容",
            trigger: "change"
          }
        ],
        userId: [
          {
            required: true,
            message: "请选择流转人",
            trigger: "change"
          }
        ]
      },
      showClueDetailForm: false,
      clueDetailForm: {
        ticketId: "",
        clueId: ""
      },
      showAction: false,
      handleActionList: [],
      handlerPersonList: [],
      intentTypeArr:["需要回电","意向不明确","待筛选","无意向","未接通","停机空号","骂人投诉","语音助手","客户忙等"],
    };
  },

  created() {
    this.getAllCity();
    this.getSupplierList();
    this.getCampaginPersonList();
    this.querySearch();
  },
  methods: {
    followAgainHandler(row){
      //

       this.$confirm("是否确认复活线索？（复活后可重新跟进）", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          workercrmapi
            .$axiosFollowAgain({ id: row.id })
            .then(res => {
              console.log(res);
              if (res.data.errno == 0) {
                this.$message.success("操作成功");
                this.querySearch();
              } else {
                this.$message.error(res.message);
              }
            });
        })
        .catch(() => { });
    },
    exportClue() {
      let req = this.listQuery;
      req.export = true;
      workercrmapi.$axiosExportClue(req);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val; // 更新选中的行数据
      console.log(this.multipleSelection);
      // this.$refs.modifyHandlerRef.showModifyHandler(row,type);
    },
    chooseAll() {
      if (this.listQuery.self == 0) {
        this.listQuery.handlerId = '';
      }
    },
    getCampaginPersonList() {
      taskApi.$axiosGetClueHandleName().then(res => {
        this.handlerPersonList = res.data.data;
      })
    },
    actionDetail(row) {
      this.showAction = true;
      taskApi.$axioGetClueHandleAction({ workerNo: row.workerNo }).then(res => {
        if (res.data.errno === 0) {
          this.handleActionList = res.data.data;
        }
      })
    },
    chooseState() {
      console.log(this.listQuery.state);
      if (this.listQuery.state.length == 0 || this.listQuery.state.length > 1) {
        this.activeName = "0";
        return;
      }
      this.activeName = this.listQuery.state + '';
    },
    handleClick(tab, event) {
      console.log('已触发')
      this.listQuery.state = [this.activeName];
      if (this.activeName == 0) {
        this.listQuery.state = [];
      }
      this.querySearch();
    },
    uploadClue() {
      this.$refs.importClueRef.showImport();
    },
    resendInterviewMsg(row) {
      console.log("row", JSON.stringify(row));
      //重发面试短信
      this.$confirm("是否重发面试短信？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          workercrmapi
            .$resendInterviewMsg({ workerNo: row.workerNo })
            .then(res => {
              if (res.errno === 0) {
                this.$message.success("重发成功");
              } else {
                this.$message.error(res.message);
              }
            });
        })
        .catch(() => { });
    },
    addClueTask(row) {
      //添加线索任务
      this.$refs.clueTaskAddRef.showAdd(row);
    },
    handleLoss(row) {
      //流失
      this.$refs.leaveLossFormRef.leaveLossClick(row, 2, 5);
    },
    handleCreate() {
      //创建线索
      this.$refs.workerClueAddFormNewRef.showAddWorkerClue(1);
    },
    handleUpdate(row) {
      //修改线索
      this.$refs.workerClueAddFormNewRef.toUpdate(row, 2);
    },
    batchModifyHandler() {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        this.$message.error('请点击表格第1列，至少选择1条线索');
        return;
      }

      let boo = true;
      this.multipleSelection.forEach(f => {
        if (!(f.state == 1 || f.state == 11 || f.state == 3)) {
          boo = false;
        }
      })

      if (!boo) {
        this.$message.error('只可选择状态为：待分配，待联系，跟进中的线索，请按状态查询过滤数据后再操作');
        return;
      }

      this.$refs.modifyHandlerRef.showModifyHandler(this.multipleSelection, 2);
    },
    toInterview(row) {
      //如果不在跟进中，则提示请先跟进
      if ( row.state != 12 && row.state != 5 && row.state != 13 && row.state != 3) {
        this.$message.error('跟进成功的线索才能发起面试');
        return;
      }
      let workerNo = row.workerNo;
      // 将workerNo存储到localStorage
      localStorage.setItem('interviewListWorkerNo', workerNo);

      // 触发storage事件（同源标签页间通信）
      window.dispatchEvent(new StorageEvent('storage', {
        key: 'interviewListWorkerNo',
        newValue: workerNo,
        oldValue: localStorage.getItem('interviewListWorkerNo')
      }));
      this.$router.push({ path: '/workermanager/empowermentTrain/interviewList', query: { wokrerNo: row.workerNo } });
    },
    toStudy(row) {
      let workerSupplier = row.workerSupplier;
      if (workerSupplier == null || workerSupplier == '') {
        this.$message.error('请先邀请上线后，再进行培训');
        return;
      }
      let workerNo = row.workerNo;
      // 将workerNo存储到localStorage
      localStorage.setItem('studentTrainWorkerNo', workerNo);

      // 触发storage事件（同源标签页间通信）
      window.dispatchEvent(new StorageEvent('storage', {
        key: 'studentTrainWorkerNo',
        newValue: workerNo,
        oldValue: localStorage.getItem('studentTrainWorkerNo')
      }));
      this.$router.push({ path: '/workermanager/empowermentTrain/studentTrain', query: { wokrerNo: row.workerNo, cityId: row.cityId, workerName: row.workerName, workerSupplier: workerSupplier } });
    },
    toOnjob(row) {
      let workerSupplier = row.workerSupplier;
      if (workerSupplier == null || workerSupplier == '') {
        this.$message.error('请先邀请上线后，再进行跟单');
        return;
      }
      let workerNo = row.workerNo;
      // 将workerNo存储到localStorage
      localStorage.setItem('documentaryWorkerNo', workerNo);

      // 触发storage事件（同源标签页间通信）
      window.dispatchEvent(new StorageEvent('storage', {
        key: 'documentaryWorkerNo',
        newValue: workerNo,
        oldValue: localStorage.getItem('documentaryWorkerNo')
      }));
      this.$router.push({ path: '/workermanager/empowermentTrain/documentary', query: { wokrerNo: workerNo } });
    },

    toWorkerList(row){
      this.$router.push({ path: '/workermanager/lifeManager/workerList', query: { wokrerNo: row.workerNo } });

    },

    handleModifyHandler(row) {
      this.$refs.modifyHandlerRef.showModifyHandler(row, 1);
    },

    onModifyHandlerConfirm(data) {
      console.log('修改跟进人:', data.handler);

      if (data.handler.id == null) {
        this.$message.error('请选择跟进人');
        return;
      }


      let params = {
        clueId: data.clueId,
        userId: data.handler.id,
        userName: data.handler.name
      }

      workercrmapi.$axiosModifyHandler(params).then(res => {
        if (res.data.errno == 0) {
          this.$message.success('修改跟进人成功');
          this.querySearch();
        } else {
          this.$message.error(res.data.errmsg);
        }
      });
    },

    handleFollow(row) {
      this.$refs.followRef.showFollow(row);
    },
    onFollowConfirm(data) {
      console.log('跟进线索:', data);

      //如果followTime 不为空，格式为yyyy-MM-dd HH:mm:ss
      if (data.followTime) {
        data.followTime = moment(data.followTime).format('YYYY-MM-DD HH:mm:ss');
      }

      workercrmapi.$axiosFollowClue(data).then(res => {
        if (res.data.errno == 0) {
          this.$message.success('保存成功');

          let code = res.data.data;

          if (code == 2) {
            //去面试
            let param = {
              id: data.clueId,
              cityId: data.cityId
            }
            this.handleInterview(param);
          }

          this.querySearch(); // 刷新列表
        } else {
          this.$message.error(res.data.message || '跟进失败');
        }
      }).catch(err => {
        this.$message.error('跟进失败');
        console.error('跟进线索失败:', err);
      });
    },

    handleInterview(row) {
      //发起面试
      this.$refs.interviewRef.init(row);
    },
    handleOffice(row) {
      //邀约
      this.$refs.workerClueAddFormNewRef.toUpdate(row, 3);
    },

    handleDetail(row) {
      this.$router.push({
        path: "/workermanager/empowermentTrain/clueDetail",
        query: {
          //  ticketId: row.ticket.id,
          clueId: row.id
        }
      });
    },
    handleCloseDetail() {
      this.showClueDetailForm = false;
    },

    //查询
    querySearch() {
      this.listQuery.pageSize = this.pageSize;
      this.listQuery.pageNum = this.currentPage;
      this.listQuery.ofJz = globalData.company.id;
      this.listQuery.export = false;

      if (this.createTimeArr == null || this.createTimeArr == []) {
        this.listQuery.createTimeStart = "";
        this.listQuery.createTimeEnd = "";
      } else if (this.createTimeArr.length > 0) {
        this.listQuery.createTimeStart = this.createTimeArr[0] + " 00:00:00";
        this.listQuery.createTimeEnd = this.createTimeArr[1] + " 23:59:59";
      }

      if (this.followupTimeArr == null || this.followupTimeArr == []) {
        this.listQuery.followupTimeStart = "";
        this.listQuery.followupTimeEnd = "";
      } else if (this.followupTimeArr.length > 0) {
        this.listQuery.followupTimeStart = this.followupTimeArr[0] + " 00:00:00";
        this.listQuery.followupTimeEnd = this.followupTimeArr[1] + " 23:59:59";
      }

      if (this.nextFollowupTime == null || this.nextFollowupTime == []) {
        this.listQuery.nextFollowupTimeStart = "";
        this.listQuery.nextFollowupTimeEnd = "";
      } else if (this.nextFollowupTime.length > 0) {
        this.listQuery.nextFollowupTimeStart = this.nextFollowupTime[0] + " 00:00:00";
        this.listQuery.nextFollowupTimeEnd = this.nextFollowupTime[1] + " 23:59:59";
      }


      if (this.listQuery.self == 1) {
        this.listQuery.handlerId = globalData.userInfo.id;
      } else {
        //  this.listQuery.handlerId = "";
      }
      workercrmapi.$axiosGetClueList(this.listQuery).then(res => {
        if (res.data.errno == 0) {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        }
      });
    },

    getAllCity() {
      //城市下拉框
      wmsApi.$axiosgetallCity({ userId: globalData.userInfo.id }).then(res => {
        if (res.data.errno == 0) {
          this.cityList = res.data.data;
        }
      });
    },
    getCityName(cityId) {
      if (cityId == null || cityId == '') {
        return '';
      }
      let nm = '';
      this.cityList.forEach(f => {
        if (f.id == cityId) {
          nm = f.cityName;
        }
      })
      return nm;
    },
    getSupplierList() {
      //获取归属
      workercrmapi
        .$axiosGetSupplierList({ companyId: globalData.company.id })
        .then(res => {
          this.supplierList = res.data.data;
        });
    },
    getSysUser() {
      //城市下拉框
      service.$axiosSysUsergetallUser().then(res => {
        if (res.data.errno == 0) {
          this.sysUserList = res.data.data;
        }
      });
    },
    getqzyx(val) {
      if (val == null || val == "") {
        return;
      }
      //1保洁、2保姆、3品类
      return val
        .replace("1", "保洁")
        .replace("2", "保姆")
        .replace("3", "品类");
    },
    timeFMT(date) {
      if (date == null || date == '') {
        return null;
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    formatState(state) {
      if (state == null || state == '' || state == undefined) {
        return '';
      }
      //  1 待上线，2已上线，3已解约,5流失
      if (state == 1) {
        return '上线中';
      }
      if (state == 2) {
        return '已上线';
      }
      if (state == 3) {
        return '已解约';
      }
      if (state == 5) {
        return '流失';
      }
    }
  },
  beforeCreate() {
    vm = this;
  }
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}

.table {
  min-height: 500px;
}

.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}

.el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}

.columntxt {
  font-weight: bold;
  font-size: 12px;
}

.columnval {
  font-weight: 400;
  font-size: 12px;
}

.columnval.clickable {
  cursor: pointer;
  color: #409eff;
  transition: all 0.3s ease;
}

.columnval.clickable:hover {
  color: #66b1ff;
  text-decoration: underline;
  transform: scale(1.05);
}
</style>
